// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".person-popup__details{max-height:450px;overflow-y:scroll}", "",{"version":3,"sources":["webpack://./resources/js/components/planning/info-components/SlotHoverInfoComponent.vue"],"names":[],"mappings":"AACA,uBACI,gBAAA,CACA,iBAAA","sourcesContent":["\n.person-popup__details {\n    max-height: 450px;\n    overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
